import React, { Component } from "react";
import { connect } from "react-redux";
import { userDetail } from "../../config/userDetails";
import TabsConstants from "../../constants";
import "../../style";
import SubMenu from "../private/SubMenu";
import ContractView from "./Contracts/ContractView";
import TicketView from "./Tickets/TicketView";
import CounterPartyTicketView from "./Tickets/CounterpartyTicketview"
import CounterpartyDashboardview from "./Tickets/CounterpartyDashboard"
import DashboardView from "./Dashboard/DashboardView";
import { isCounterParty } from "../Common/CheckAuthorization";

class LoginHome extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      activeTabValue: ""
    };
  }

  componentWillMount() {
    const path = this.props.route.match.path;
    this.setState({ children: path });
    if (path.includes("dashboard") || path === "/app") {
      this.setState({ activeTabValue: "dashboard" });
    } else if (path.includes("tickets")) {
      this.setState({ activeTabValue: "tickets" });
    } else if (path.includes("contracts")) {
      this.setState({ activeTabValue: "contracts" });
    }
  }

  componentWillReceiveProps(nextProps) {}

  render() {
    const { activeTabValue, children } = this.state;
    const { HomeScreen } = TabsConstants;
    const menuName = "Home";
    return (
      <div className="">
        <SubMenu
          menuName={menuName}
          tabsVisible={HomeScreen[userDetail().roleName]}
          routes={this.props.route}
          activeTabValue={activeTabValue}
          handleChangeTabBody={this.updateTabBody}
        />
        {(children === "/app/dashboard" || children === "/app") && (
          isCounterParty()?<CounterpartyDashboardview />:<DashboardView />
        )}
        {children === "/app/counterPartytickets" && <CounterPartyTicketView />}
        {children === "/app/tickets" && <TicketView />}
        {userDetail().roleName !== "FARM_EMPLOYEE" &&
          (children === "/app/contracts" && <ContractView />)}
      </div>
    );
  }LoginHome
}
export default connect(
  null,
  {}
)(LoginHome);



// WEBPACK FOOTER //
// ./src/components/private/LoginHome.js